import { useTranslation } from 'react-i18next'

import { CredentialField, CredentialsCardProps, CredentialsFormCard } from './credentials-form-card'
import { usePointCentralCredentials, useSavePointCentralCredentials } from './provider-connections'

export const PointCentralCard = ({ buildingId, ...props }: CredentialsCardProps) => {
  const { t } = useTranslation(['organisation'])
  const { configured, isLoading } = usePointCentralCredentials(buildingId)
  const { isPending, mutateAsync: save } = useSavePointCentralCredentials()

  const fields: CredentialField[] = [
    {
      error: t('organisation:places.integrations.pointCentral.errors.username'),
      label: t('organisation:places.integrations.pointCentral.fields.username.label'),
      name: 'username',
      placeholder: t('organisation:places.integrations.pointCentral.fields.username.placeholder'),
    },
    {
      error: t('organisation:places.integrations.pointCentral.errors.password'),
      label: t('organisation:places.integrations.pointCentral.fields.password.label'),
      name: 'password',
      placeholder: t('organisation:places.integrations.pointCentral.fields.password.placeholder'),
      secret: true,
    },
    {
      error: t('organisation:places.integrations.pointCentral.errors.haiku'),
      label: t('organisation:places.integrations.pointCentral.fields.haiku.label'),
      name: 'haiku',
      placeholder: t('organisation:places.integrations.pointCentral.fields.haiku.placeholder'),
      secret: true,
    },
  ]

  return (
    <CredentialsFormCard
      {...props}
      configured={configured}
      fields={fields}
      isLoading={isLoading}
      isSaving={isPending}
      onSave={(values) =>
        save({
          buildingId,
          haiku: values.haiku,
          password: values.password,
          username: values.username,
        })
      }
    />
  )
}
